ApiError = require 'network/api-error'
Auth = require 'db/auth'
Payloads = require 'network/payloads'
EnterpriseAdminDashboardView = undefined
queueRequire -> EnterpriseAdminDashboardView = require 'views/enterprise/enterprise-admin-dashboard-view'
EnterpriseAdminDashboardLoadingView = undefined
queueRequire -> EnterpriseAdminDashboardLoadingView = require 'views/enterprise/enterprise-admin-dashboard-loading-view'
Enterprise = undefined
queueRequire -> Enterprise = require 'models/enterprise'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
log = require 'debug/log'
Promise = require 'bluebird'
$ = require 'jquery'

module.exports =
  routes: [
    ['e/:name/admin', 'enterpriseAdminDashboardView']
    ['e/:name/admin/:tab', 'enterpriseDashTab']
  ]

  displayEnterprisePage: (settings) ->
    { enterpriseName, viewClass, tab } = settings

    log('controller', ['enterprise'])

    Promise.using @getSpinner(), =>
      Enterprise.load enterpriseName, Payloads.enterprise, ModelCache
      .then (enterprise) =>
        # We need to check this here rather than at the beginning of the method
        # cause sometimes Auth.me() doesn't yet exist there, but it always
        # exists here.
        unless Auth.me().get('confirmed')
          @displayErrorPage
            errorType: 'unconfirmedEnterpriseNotFound'
            email: Auth.me().get('email')
          return

        if !enterprise.isRealEnterprise()
          @displayErrorPage()
          return

        @clearPreviousView()
        @setViewType(enterprise)
        @showHeader()
        $('#classic-body').addClass('body-tabbed-page')

        loadingView = @topLevelView(EnterpriseAdminDashboardLoadingView, enterprise)
        $('#content').html(loadingView.render().el)

        isCachedModelValidPredicates = [
         (enterprise) -> enterprise.get('idOrganizations')?.length == enterprise.organizationList.length
        ]

        Enterprise.load enterprise.id, Payloads.enterpriseOrganizations, ModelCache, isCachedModelValidPredicates
        .then (enterpriseWithOrganizations) =>
          options = { modelCache: ModelCache, initialTab: tab }
          enterpriseView = @topLevelView(viewClass, enterpriseWithOrganizations, options)
          $('#content').html(enterpriseView.render().el)

        title = enterprise.get('displayName')

        @setLocation
          title: title
          location: settings.getLocation.call(@, enterprise.get('name'), tab)

        return
      .catch ApiError, =>
        @displayErrorPage()
        return

  enterpriseAdminDashboardView: (enterpriseName) ->
    @displayEnterprisePage
      enterpriseName: enterpriseName
      viewClass: EnterpriseAdminDashboardView
      getLocation: @getEnterpriseAdminDashboardUrl
    .done()

  enterpriseDashTab: (enterpriseName, tab) ->
    if tab != 'members' && tab != 'teams'
        @displayErrorPage()
        return

    @displayEnterprisePage
      enterpriseName: enterpriseName
      viewClass: EnterpriseAdminDashboardView
      getLocation: @getEnterpriseAdminDashboardUrl
      tab: tab
    .done()



// WEBPACK FOOTER //
// ./app/scripts/controller/enterprise-routes.coffee